import {
    Hammer,
    Home as HomeIcon,
    Layers,
    Plug,
    Wrench,
    Building2,
    PaintRoller,
    Ruler,
    HardHat,
} from "lucide-react";

export const SITE = {
    name: "Dandy Builders",
    fullName: "Dandy Builders & Property Care Ltd",
    tagline: "Crafted by Hand. Built to Last.",
    location: "Wokingham, Berkshire",
    foundedYear: 2022,
    phone: "07786 732510",
    phoneLink: "tel:07786732510",
    whatsapp: "https://wa.me/447786732510",
    email: "office@dandybuilders.co.uk",
    emailLink: "mailto:office@dandybuilders.co.uk?subject=Quotation%20Enquiry",
    googleReviewsUrl: "https://share.google/phdrVccvWQ9iKrIOe",
    googleRating: 5.0,
    googleReviewCount: 9,
    facebook: "https://www.facebook.com/profile.php?id=100090401305118",
    instagram: "https://www.instagram.com/dandybuilders.ltd",
    serviceArea:
        "Wokingham, Reading, Bracknell, Henley, Twyford, Crowthorne and surrounding Berkshire areas",
    hours: [
        { day: "Mon – Fri", time: "7:30am – 6:00pm" },
        { day: "Saturday", time: "8:00am – 2:00pm" },
        { day: "Sunday", time: "Emergency call-outs" },
    ],
};

export const SERVICES = [
    {
        slug: "extensions",
        name: "Extensions",
        icon: HomeIcon,
        short: "Single & double-storey rear, side-return and wrap-around extensions.",
        description:
            "From planning drawings to plastered finish — we handle the lot. Open-plan kitchen-diners, bi-fold doors, lantern roofs, the works. Honest pricing, fixed quotes.",
        bullets: [
            "Single & double storey",
            "Side-return & wrap-around",
            "Steel beam installation",
            "Bi-fold door fitting",
        ],
    },
    {
        slug: "loft-conversions",
        name: "Loft Conversions",
        icon: Layers,
        short: "Dormer, hip-to-gable, mansard and Velux conversions.",
        description:
            "Add a bedroom, bathroom or home office without leaving home. Fully managed — drawings, building regs, structural calcs and finish.",
        bullets: [
            "Dormer & hip-to-gable",
            "En-suites & dressing rooms",
            "Building reg approval",
            "Velux & rooflights",
        ],
    },
    {
        slug: "groundworks",
        name: "Groundworks",
        icon: HardHat,
        short: "Foundations, drainage, retaining walls and site preparation.",
        description:
            "The bit no-one sees but everything stands on. Reinforced concrete foundations, soakaways, drainage and full site clearance.",
        bullets: [
            "Strip & raft foundations",
            "Drainage & soakaways",
            "Retaining walls",
            "Site clearance",
        ],
    },
    {
        slug: "electrical",
        name: "Electrical",
        icon: Plug,
        short: "Domestic rewires, consumer units, EICR, and certified installs.",
        description:
            "18th edition certified work — full rewires, partial rewires, fuse-board upgrades, EV chargers and EICR safety inspections.",
        bullets: [
            "Full & partial rewires",
            "Consumer unit upgrades",
            "EICR certification",
            "EV charger install",
        ],
    },
    {
        slug: "mechanical",
        name: "Mechanical & Heating",
        icon: Wrench,
        short: "Boilers, central heating, plumbing and HVAC servicing.",
        description:
            "New combi boiler installs, full system upgrades, smart thermostats, underfloor heating and bathroom plumbing.",
        bullets: [
            "Boiler installs & swaps",
            "Underfloor heating",
            "Bathroom plumbing",
            "System power-flush",
        ],
    },
    {
        slug: "renovations",
        name: "Renovations",
        icon: PaintRoller,
        short: "Kitchens, bathrooms, full-house refurbs and period restoration.",
        description:
            "Sympathetic restoration of period homes through to modern open-plan refurbs. Joinery, plastering, decorating — all in-house.",
        bullets: [
            "Kitchen & bathroom fits",
            "Period restoration",
            "Full house refurbs",
            "Garage conversions",
        ],
    },
    {
        slug: "property-care",
        name: "Property Care",
        icon: Building2,
        short: "Repairs, maintenance and routine inspections for landlords.",
        description:
            "From a dripping tap to a full landlord package — we look after your property so you don't have to worry about it.",
        bullets: [
            "Routine inspections",
            "Reactive repairs",
            "Painting & decorating",
            "Garden & grounds",
        ],
    },
    {
        slug: "consultation",
        name: "Consultation & Surveys",
        icon: Ruler,
        short: "Quantity & building surveying, costings and project management.",
        description:
            "Pre-purchase surveys, defect analysis, party wall advice, cost estimation and full project management — by experienced professionals.",
        bullets: [
            "Pre-purchase surveys",
            "Defect analysis",
            "Party wall advice",
            "Project management",
        ],
    },
];

export const FAQS = [
    {
        q: "Are you fully insured?",
        a: "Yes — we hold full public liability insurance and carry employers' liability cover for all our team. Certificates available on request.",
    },
    {
        q: "Do you handle planning permission and building regs?",
        a: "Absolutely. We work alongside trusted architects to produce drawings, submit applications and liaise with building control on your behalf.",
    },
    {
        q: "Do you provide fixed-price quotes?",
        a: "Yes. After a free site visit we'll send a detailed, itemised written quote so there are no surprises. We also offer no-pressure cost estimates if you're still planning.",
    },
    {
        q: "What areas do you cover?",
        a: "We're based in Wokingham, Berkshire and regularly work across Reading, Bracknell, Henley, Twyford, Crowthorne and the surrounding villages.",
    },
    {
        q: "How long does an extension typically take?",
        a: "A single-storey rear extension usually takes 10–14 weeks once on site. We'll give you a clear programme up front and keep you updated weekly.",
    },
    {
        q: "Are your electricians and gas engineers certified?",
        a: "Yes — our electrical work is 18th edition certified and our gas/heating engineers are Gas Safe registered. All certificates are issued on completion.",
    },
    {
        q: "Do you offer a guarantee on your work?",
        a: "We provide a workmanship guarantee on every job, plus all manufacturer warranties on materials and appliances. We stand behind what we build.",
    },
];

export const PROJECT_TYPES = [
    "Extension",
    "Loft Conversion",
    "Groundworks",
    "Electrical Work",
    "Mechanical / Heating",
    "Renovation",
    "Property Care",
    "Consultation / Survey",
    "Other",
];
